module.exports = __webpack_public_path__ + "static/assets/b99ffc1a9c2e3ad8c9d06310c525b4c9.svg";